<template>
<div class="ActivityleaderList">
    <div class="bgc box-shadow ActivityleaderList-title">
        <div class="classes blod">{{item.eventname}}</div>
    </div>
    <div class="filters padding-20 bgc">
        <div class="add">
        </div>
        <div class="search">
            <el-input v-model="param.key" placeholder="请输入名称查询" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="headername" label="团长名称"  min-width="250px" class-name="title">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.logourl" :alt="scope.row.headername" preview="LeaderList">
                        <span>{{scope.row.headername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="openeventtime" label="开团时间" class-name="center"  min-width="120px">
                <template slot-scope="scope">{{scope.row.isopenevent?scope.row.openeventtime: '--'}}</template>
            </el-table-column>
            <el-table-column prop="isopenevent" label="是否开团" class-name="center">
                <template slot-scope="scope">{{scope.row.isopenevent?'是':'否'}}</template>
            </el-table-column>
            <el-table-column prop="brokeragerateheader" label="商品佣金" class-name="center">
                <template slot-scope="scope">￥{{scope.row.brokeragesale}}</template>
            </el-table-column>
            <el-table-column prop="brokerageraterecommend" label="团长佣金额" class-name="center">
                <template slot-scope="scope">￥{{scope.row.brokerageheader}}</template>
            </el-table-column>
            <el-table-column prop="brokeragerateheader" label="合计佣金" class-name="center">
                <template slot-scope="scope">￥{{scope.row.brokeragetotal}}</template>
            </el-table-column>
            <el-table-column prop="brokeragesettled" label="待发佣金" class-name="center">
                <template slot-scope="scope">￥{{scope.row.brokeragesettled}}</template>
            </el-table-column>
            <el-table-column prop="brokeragepaystatus " label="是否发放" class-name="center">
                <template slot-scope="scope">{{scope.row.brokeragepaystatus?'是':'否'}}</template>
            </el-table-column>
        </el-table>
        <div class="page" style="margin-top: 15px; text-align: center">
            <el-pagination
                background
                @current-change="handleSizeChange"
                :current-page.sync="page.page"
                :page-size="page.pageSize"
                :pager-count="11"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {getHeaderListByBrandEvent} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ActivityleaderList',
    data() {
        return {
            param: {
                key: '',
                eventid: this.$route.query.eventid ? this.$route.query.eventid : ''
            },
            item:{
                eventname:  this.$route.query.eventname ? this.$route.query.eventname : ''
            },
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
            tableData: [],
            total: 0
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleSizeChange() {
            this._getList()
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getHeaderListByBrandEvent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.ActivityleaderList {
    .ActivityleaderList-title {
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        margin-bottom: 30px;
        .classes {
            margin-bottom: 0;
        }
        .el-input__icon {
            line-height: 1;
        }
    }
    .filters{
        margin-bottom: 0;
    }
    .imageText{
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
